// extracted by mini-css-extract-plugin
export var accent = "_85-4";
export var add = "_85-j";
export var addIcon = "_85-k";
export var deleteIcon = "_85-i";
export var disabled = "_85-9";
export var ellipsis = "_85-f";
export var error = "_85-3";
export var form = "_85-5";
export var hideFocus = "_85-2";
export var icon = "_85-7";
export var input = "_85-e";
export var listItem = "_85-h";
export var mediumHeight = "_85-b";
export var noBorder = "_85-8";
export var noRadius = "_85-1";
export var shortHeight = "_85-a";
export var tallHeight = "_85-c";
export var textInput = "_85-0";
export var vertical = "_85-g";
export var veryTallHeight = "_85-d";
export var widget = "_85-6";